/**
 * 业务类型。3
 * 01-国内汇款 02-国外汇款 03-人行大额 04-人行小额 05-现金存款 06-转帐收入 07-汇票 08-本票 09-支票 10-冲账
 * 11-冲正 12-承兑汇票 13-托收承付 14-保证金 15-现金取款 16-转帐支出 17-贷款放款 18-贷款还款
 * 21-实时汇划 22-退汇 31-结息 32-批量收费 41-收费 99-其他
 * TS-国外；TE-异地中行 ；TL-跨行汇划 ；CI-辖内 TN-国内异地中行；CO-辖内客户类转账（同机构转账和不同机构间）；TW-跨行汇划（CNAPS）；TT-国外
 * */

const BusinessTypeMAP: Record<string, string> = {
  '01': '国内汇款',
  '02': '国外汇款',
  '03': '人行大额',
  '04': '人行小额',
  '05': '现金存款',
  '06': '转帐收入',
  '07': '汇票、',
  '08': '本票',
  '09': '支票',
  10: '冲账',
  11: '冲正',
  12: '承兑汇票',
  13: '托收承付',
  14: '保证金',
  15: '现金取款',
  16: '转帐支出',
  17: '贷款放款',
  18: '贷款还款',
  21: '实时汇划',
  22: '退汇',
  31: '结息',
  32: '批量收费',
  41: '收费',
  99: '其他',
  TS: '国外',
  TE: '异地中行',
  TL: '跨行汇划',
  CI: '辖内',
  TN: '国内异地中行',
  CO: '辖内客户类转账（同机构转账和不同机构间）',
  TW: '跨行汇划（CNAPS）',
  TT: '国外'
}
export const BusinessTypeFormat = (key: string | null): string => {
  if (key) {
    return BusinessTypeMAP[key] ?? key // 未映射时返回原值
  }
  return ''
}
